import { forwardRef, Ref } from "react";
import { findWhere } from "underscore";

import { callFunctionIfExists } from "../../../../utils/GeneralUtils";

interface SubitemDisplayProps {
  module: any;
  existingValue: any;
  onOpen: () => void;
  onView: (data: any) => void;
}

function SubitemDisplay(
  { module, existingValue, onOpen, onView }: SubitemDisplayProps,
  ref: Ref<HTMLDivElement>
) {
  const subitemAPIName = existingValue?._SubitemFieldAPIName;

  const foundField = findWhere(module?.Fields, {
    APIName: subitemAPIName,
  });
  const name = existingValue?.[foundField?.SubitemRecordNameField];

  return (
    <div
      ref={ref}
      className="text-primary-dark font-weight-500 text-truncate"
      style={{ maxWidth: 340 }}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();

        callFunctionIfExists(onOpen);

        onView({
          isSubitem: true,
          recordID: existingValue?.id,
          recordModule: module,
          subitemSchema: foundField,
          subitemID: existingValue?._SubitemID,
        });
      }}
    >
      {name || "(No Name)"}
    </div>
  );
}

export default forwardRef(SubitemDisplay);
